import {create} from 'zustand';
import {Filter} from '../types';

interface ContractTableFiltersState {
  filters: Filter[];

  setFilter: (filter: Filter) => void;
  setFilters: (filters: Filter[]) => void;
  removeFilter: (index: number) => void;
  resetFilters: () => void;
}

export const useContractsTableFiltersStore = create<ContractTableFiltersState>((set) => ({
  filters: [],

  setFilter: (filter: Filter) => set((prev) => ({filters: [...prev.filters, filter]})),
  setFilters: (filters: Filter[]) => set({filters}),
  removeFilter: (index: number) => set((prev) => ({filters: prev.filters.filter((_, i) => i !== index)})),
  resetFilters: () => set({filters: []}),
}));

export const {setFilter, removeFilter, resetFilters, setFilters} = useContractsTableFiltersStore.getState();
